import { Component, OnDestroy } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { CommunicationService } from 'src/app/services/communication';
import { DashboardWidgetBasicComponent } from '../../dashboard-widget-basic/dashboard-widget-basic.component';

@Component({
  selector: 'app-minute-by-minute',
  templateUrl: './minute-by-minute.component.html',
  styleUrls: ['./minute-by-minute.component.scss'],
})
export class MinuteByMinuteComponent extends DashboardWidgetBasicComponent implements OnDestroy {
  public tableConfig: ITableConfig;
  public displayMessage = false;

  constructor(
    public booleanBarService: BooleanStateService,
    public communication: CommunicationService,
    public parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    private tableService: TableConfigService,
    protected screenViewService: ScreenViewService,
  ) {
    super(booleanBarService, communication, parameterService, cacheService, machineContext, screenViewService);
    this.initRequestParams();
  }

  /**
   * Init request params
   */
  private initRequestParams(): void {
    this.params = {
      hasShift: true,
      hasCompany: true,
      hasDate: true,
      hasMachineType: true,
      hasZone: true,
    };
  }

  /**
   *  buildView Minute by MInute
   *
   * @param values parameter value
   */
  public buildView(values: any): void {
    super.buildView(values);
    this.getDataMinutebyMinute(values);
  }

  /**
   * Get data Ninute by minute
   */
  public async getDataMinutebyMinute(dataByMinute: any): Promise<any> {
    if (dataByMinute.length) {
      this.displayMessage = true;
      this.setTableDetailConfig(dataByMinute);
    } else {
      this.displayMessage = false;
    }
  }

  /**
   * config table Detail Minute by minute
   *
   * @param tableData config data minute a minute
   */
  private setTableDetailConfig(tableData: any[]): void {
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns: ['timestamp', 'loopDuration'],
      replaceColumnName: [
        { prevName: 'machine', newName: 'device' },
        { prevName: 'operator', newName: 'madeby' },
      ],
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns: ['timestamp', 'loopDuration'],
      dateConfig: [{ field: 'resultTime', format: 'dateTimeText' }],
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset }), 0);
  }

  /**
   * On destroy component
   */
  public OnDestroy(): void {
    super.ngOnDestroy();
  }
}
